import React from 'react';
import {Divider, Link} from "@nextui-org/react";

const Footer = ({className, style}) => {
    return (
        <div className={className} style={style}>
            <Divider/>
            <div className={'flex justify-between  p-5 md:grid-cols-2 items-center flex-col md:flex-row'}>
                <p className={'align-middle  md:justify-start items-center'}>
                    © 2023 RbTechLabs, Inc. All rights reserved.
                </p>
                <div className={'flex justify-between'}>
                    <Link className={'px-3'}>
                        Terms & conditions
                    </Link>
                    <Link className={'px-3'}>
                        Privacy Policy
                    </Link>
                    <Link className={'px-3'}>
                        FAQ
                    </Link>
                    <Link className={'px-3'}>
                        How to use
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Footer;